
import { defineComponent } from "vue";

export default defineComponent({
  name: "Home",
  methods: {
    isActive(path) {
      return this.$route.path === path;
    },
  },
});
